<form [formGroup]="mathForm">
  <div class="equation">{{ a }} + {{ b }} =</div>

  <input appAnswerHighlight formControlName="answer" />
</form>

<div class="stats">
  {{ secondsPerSolution | number: "1.1-3" }}
</div>
